import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";

function JuiceCenterDetail({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);
  // const [dataLimit, setDataLimit] = useState({});

  useEffect(() => {
    setData(allData);

    // Initialize dataLimit for each item with default value
    const initialLimits = allData.reduce((limits, item, index) => {
      limits[index] = Math.min(item.items.length, 3); // Show up to 3 items initially
      return limits;
    }, {});
    // setDataLimit(initialLimits);
  }, [allData]);

  // const handleViewAll = (index) => {
  //   setDataLimit((prevLimits) => ({
  //     ...prevLimits,
  //     [index]: prevLimits[index] === 3 ? data[index].items.length : 3,
  //   }));
  // };

  // Define columns for the items table
  const itemsColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Sale",
      dataIndex: "sale",
      key: "sale",
    },
    {
      title: "Sale Price",
      dataIndex: "salePrice",
      key: "salePrice",
    },
    {
      title: "Sale During Pd",
      dataIndex: "saleDuringPd",
      key: "saleDuringPd",
    },
    {
      title: "Total Sale",
      dataIndex: "totalSale",
      key: "totalSale",
    },
    {
      title: "Gross Profit",
      dataIndex: "grossProfit",
      key: "grossProfit",
    },
    {
      title: "Gross Margin",
      dataIndex: "grossMargin",
      key: "grossMargin",
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
    // Add other columns as needed
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
               <h5 className="card-title">{item?.shop?.name}</h5>
               <p>Working Days: {item?.shop?.workingDays}</p>
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="text-danger">Items</h5>
                  {item.items && item.items.length > 0 ? (
                    <div className="table-responsive mb-4">
                      <Table
                        dataSource={item.items}
                        columns={itemsColumns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      {/* {item.items.length > 3 && (
                        <Button onClick={() => handleViewAll(index)} block>
                          {dataLimit[index] === 3 ? "View All" : "Show Less"}
                        </Button>
                      )} */}
                    </div>
                  ) : (
                    <div className="border rounded p-4 mb-2">
                      <p>No items available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default JuiceCenterDetail;
